import { Helmet } from 'react-helmet-async'
import { FadeIn } from '@components/animations/FadeIn/FadeIn'
import { Rocket, Globe, Lightbulb, Users, Target, TrendingUp } from 'lucide-react'

const vision2030 = [
  {
    icon: Globe,
    title: 'Pan-India Expansion',
    target: '25+ States',
    description: 'Establish presence across all major states with regional offices and local execution capabilities.',
  },
  {
    icon: Users,
    title: 'Team Growth',
    target: '2000+ Employees',
    description: 'Build a diverse team of talented professionals committed to excellence and innovation.',
  },
  {
    icon: TrendingUp,
    title: 'Revenue Target',
    target: '₹500 Crores',
    description: 'Achieve sustainable growth while maintaining profitability and operational excellence.',
  },
  {
    icon: Lightbulb,
    title: 'Innovation Hub',
    target: '5 R&D Centers',
    description: 'Establish centers of excellence for AI/ML, IoT, Blockchain, and emerging technologies.',
  },
  {
    icon: Target,
    title: 'Project Impact',
    target: '1000+ Projects',
    description: 'Complete 1000+ transformative projects impacting 100+ million citizens.',
  },
  {
    icon: Rocket,
    title: 'Global Presence',
    target: '5 Countries',
    description: 'Expand internationally with focus on Southeast Asia, Middle East, and Africa.',
  },
]

const FutureVision = () => {
  return (
    <>
      <Helmet>
        <title>Future Vision 2030 | Eonixa Dynamics</title>
        <meta name="description" content="Our vision for 2030 - Pan-India presence, 2000+ employees, ₹500 Crores revenue, and global expansion" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 pt-32 pb-20">
        <div className="section-container">
          <FadeIn>
            <div className="text-center mb-16">
              <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold text-primary-600 mb-4">
                Vision 2030
              </span>
              <h1 className="text-4xl font-bold text-gray-900">Building The Future</h1>
              <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
                Our ambitious roadmap for the next decade.
                We're not just building a company - we're building institutions that will
                serve millions for generations to come.
              </p>
            </div>
          </FadeIn>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 mb-16">
            {vision2030.map((item, index) => {
              const Icon = item.icon
              return (
                <FadeIn key={item.title} delay={index * 0.1}>
                  <div className="group h-full rounded-2xl bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-card">
                    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-colors">
                      <Icon className="h-7 w-7" />
                    </div>
                    <h3 className="mb-2 text-lg font-bold text-gray-900">
                      {item.title}
                    </h3>
                    <p className="mb-3 text-2xl font-bold text-primary-600">
                      {item.target}
                    </p>
                    <p className="text-gray-600 text-sm">{item.description}</p>
                  </div>
                </FadeIn>
              )
            })}
          </div>

          <FadeIn delay={0.6}>
            <div className="rounded-2xl bg-gradient-to-r from-primary-900 via-primary-800 to-primary-900 p-12 text-center text-white">
              <h2 className="mb-6 text-3xl font-bold">Our Commitment</h2>
              <p className="mx-auto max-w-3xl text-lg text-gray-200 mb-8">
                "By 2030, Eonixa Dynamics will be recognized as India's most trusted
                partner for Government Technology and Infrastructure transformation.
                We will have impacted 100+ million citizens through our solutions,
                created 2000+ jobs, and set new benchmarks for quality and innovation."
              </p>
              <div className="flex flex-wrap justify-center gap-8">
                <div className="text-center">
                  <p className="text-4xl font-bold text-accent-400">2030</p>
                  <p className="text-sm text-gray-300">Target Year</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-bold text-accent-400">100M+</p>
                  <p className="text-sm text-gray-300">Lives Impacted</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-bold text-accent-400">1000+</p>
                  <p className="text-sm text-gray-300">Projects</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </>
  )
}

export default FutureVision
